import React from 'react'
import {Link} from 'gatsby'
import config from "../../data/SiteConfig";
import styles from './navbar.module.scss'

const Navbar = () => {
    const navLinks = [
        {
            to: "/",
            text: "Home"
        },
        {
            to: "/about",
            text: "About"
        }
    ]
    return (
        <div>
            <nav className={styles.navbar}>
                <div className={styles.container}>
                    <Link to="/"><span className={styles.brand}>Kuge</span> </Link>
                    <div className={styles.navLinks}>
                        {/* <Link to="/" activeClassName={styles.activeLink}>Home</Link> */}
                        {/* <Link to="/about" activeClassName={styles.activeLink}>About</Link> */}
                        {navLinks.map(link => <Link to={link.to} activeClassName={styles.activeLink}>{link.text}</Link>)}
                    </div>
                    <div className={styles.userLinks}>
                        {config.userLinks.map(userLink => <a href={userLink.url} target="_blank"><i className={userLink.iconClassName}></i></a>)}
                    </div>
                </div>
                
            </nav>
        </div>
    )
}

export default Navbar
